/*****************************************************/
/* 処　理：SMS001 メインメニュー 画面
/*
/* 概　要：INパラメータ
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS001MainMenuInVO {

  /** 契約情報ID（ハッシュ値） */
  hashId!: string;

  /** 取引メニュー番号 */
  menuNo!: string;

  /** 言語区分 */
  languageType!: string;


  /* 画面表示詳細情報 */

  /** 生年月日（YYYYMMDD） */
  birthday!: string;

}
